import { promotionValidDays } from '../../../domain/utils/package.validity';

export const PROMOTION_VALID_DAYS_PARAM = 'promotionValidDays';

export const thanksPurchaseUrl = (product, voucher) => {
    const url = `/customers/thanks-purchase?&productId=${product?.id}`;
    const validDays = promotionValidDays(voucher);
    return validDays ? `${url}&${PROMOTION_VALID_DAYS_PARAM}=${validDays}` : url;
};
